import React, { Component } from "react";
import "react-bootstrap";

import store from "../../../store/configureStore";
import BlogSingleMain from "./BlogSingleMain";
import BlogSingleSideBar from "./BlogSingleSideBar";
import { changeActiveItemAction } from "../../../actions/navAction";
import { changeTopBannerAction } from "../../../actions/topBannerAction";
import {
  Businesses,
  PagesForCaption,
  CaptionCodes,
} from "../../../config/Helper";
import captionApi from "../../../api/captionApi";

import { withRouter } from "react-router-dom";
class BlogSingle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sectionTitle: {},
      id: parseInt(this.props.match.params.id, 10),
      business: Businesses.indexOf(this.props.match.params.business),
      curPage: 1,
    };

    this.getSectionTitles = this.getSectionTitles.bind(this);
  }

  componentWillMount() {
    store.dispatch(changeActiveItemAction(Businesses.indexOf("blog")));
    store.dispatch(
      changeTopBannerAction({
        page: "blog_detail",
        showSearch: false,
        isHome: false,
      })
    );
  }

  componentDidMount() {
    window.onSetClass("light");
    window.scrollTop("#top_banner");
  }

  componentWillUnmount() {}

  componentDidUpdate() {
    store.dispatch(
      changeTopBannerAction({ page: "blog_detail", showSearch: false })
    );
    window.scrollTop("#top_banner");
  }

  componentWillReceiveProps(newProps) {
    this.getSectionTitles();
    const search = this.props.history.location.search.split("?");
    let queryParams;
    if (search.length > 1) {
      const query = search[1].split("=");

      if (query.length) {
        queryParams = { [query[0]]: parseInt(query[1]) };
        this.setState({ curPage: queryParams.page });
      }
    }
    this.setState({
      id: parseInt(newProps.match.params.id, 10),
      business: Businesses.indexOf(newProps.match.params.business),
    });
    this.getSectionTitles();
  }

  getSectionTitles() {
    captionApi.getCaptions("blog_detail").then((json) => {
      if (json.status === 200) {
        this.setState({
          sectionTitle: json.data,
        });
      } else {
      }
    });
  }

  getPageName(business) {
    var business_name = Businesses[business];

    if (business_name === "news") {
      return "news_detail";
    } else if (business_name === "event") {
      return "event_detail";
    } else if (business_name === "experience") {
      return "testimonial_detail";
    } else if (business_name === "activity") {
      return "activity_detail";
    } else if (business_name === "agency_news") {
      return "agency_news_detail";
    } else if (business_name === "folkways") {
      return "folkway_detail";
    } else if (business_name === "article") {
      return "article_detail";
    } else {
      return "blog_detail";
    }
  }

  render() {
    return (
      <div>
        {/* <div className={"return-title"} onClick={() => { this.props.history.push(`/blog?page=${this.state.curPage}`) }}> 목록으로 가기</div> */}
        <section className="ftco-section detail-blog" id="resort-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 pr-lg-4">
                <BlogSingleMain
                  id={this.state.id}
                  business={this.state.business}
                />
              </div>
              <div className="col-lg-4 p-4 recent-place">
                <BlogSingleSideBar
                  title={
                    this.state.sectionTitle[
                      CaptionCodes[
                        PagesForCaption.indexOf("blog_detail")
                      ].indexOf("blog_single_other_blogs")
                    ] === undefined
                      ? ""
                      : this.state.sectionTitle[
                          CaptionCodes[
                            PagesForCaption.indexOf("blog_detail")
                          ].indexOf("blog_single_other_blogs")
                        ].title
                  }
                  id={this.state.id}
                  business={this.state.business}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(BlogSingle);
